export default __webpack_public_path__ + "static/media/lieferheld_background_xl2.5f350ef8.jpg";